export class Validator {
  public static IsValidEmail(email: string): boolean {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(email)
  }

  public static isPasswordValid(v: string): boolean {
    let empty = /\s/
    let reg = /[a-zàäâéèêëïîöôùüû]/
    let regMaj = /[A-Z]/
    let num = /[1-9]/
    const isValid=  !empty.test(v) && reg.test(v) && regMaj.test(v) && num.test(v)
    return isValid
  }
}



// WEBPACK FOOTER //
// ./src/utils/Validator.util.ts